import { axios } from "@/utils/request";

//post
export function postAction(url, parameter) {
	// console.log("Management.js.postAction(): url=", url, "parameter=",parameter)
	return axios({
		url: url,
		method: "POST",
		data: parameter,
	});
}
//get
export function getAction(url, params, config) {
	// console.log("Management.js.getAction(): url=", url, "params=",params, "config=", config)
	return axios({
		url,
		method: "GET",
		params,
		...config,
	});
}
